<template>
    <mc-modal
        v-model="visible"
        width="70%"
    >
        <div
            v-for="item in weakValidateResult"
            :key="item.weakValidTitle"
        >
            <mc-title
                :title="item.weakValidTitle"
                :level="2"
            />

            <!-- eslint-disable-next-line vue/no-v-html -->
            <div v-html="item.message">
            </div>
        </div>

        <div
            slot="footer"
            style="text-align: center;"
        >
            <mc-button
                type="primary"
                style="margin-right: 10px;"
                @click="handleContinue"
            >
                确认无误，继续提交
            </mc-button>
            <mc-button @click="handleCancel">
                返回确认
            </mc-button>
        </div>
    </mc-modal>
</template>

<script>
import { ref, getCurrentInstance } from '@vue/composition-api';

// weakValidateSubmit... 相关接口type弱校验枚举
const weakValidateMap = Object.freeze({
    weightValidate: 101, // 重量校验
    recipeValidate: 102, // 配方单校验
    sharedWarehousePurchasePriceValidate: 103, // 共享仓采购价校验
    attrChangeValidate: 104, // 属性变更校验
    processChangePriceValidate: 105, // 加工品定价方式校验
    suppliersChangeValidate: 106, // 变更默供校验
    nutritionRepeatValidate: 107, // 内容模块营养成分相关重复信息校验
    nutritionTableValidate: 108, // 营养成分表相关属性-属性值校验
});

// weakValidateSubmit... 相关接口code弱校验枚举
const codeMap = Object.freeze({
    noRequired: 1, // 无需校验
    writeOver: 2, // 已经填写原因
    needWrite: 3, // 需要填写原因
    pass: 4, // 校验通过
    needOpen: 5, // 需要弹窗提示
});

const sceneUrlMap = Object.freeze({
    content: '/api/vss/shepherd/product/bizcenter/SkuFlowTService/weakValidateSubmitModifySkuContentFlow',
    newProduct: '/api/vss/shepherd/product/bizcenter/VssNewSaleCommandTService/weakValidateSaveDraft',
});

export default {
    name: 'WeakValidateModal',

    props: {
        scene: {
            type: String,
            default: 'content',
        },
    },
    setup(props) {
        const { proxy } = getCurrentInstance();
        const visible = ref(false);
        const weakValidateResult = ref([]);

        // 验证类型配置映射
        const validationConfig = {
            [weakValidateMap.nutritionRepeatValidate]: {
                title: '内容模块营养成分相关重复信息校验',
            },
            [weakValidateMap.nutritionTableValidate]: {
                title: '营养成分表相关属性-属性值校验',
            },
        };

        /**
         * 获取验证结果
         * @param {Object} params - 请求参数
         * @returns {Promise<Object>} 验证响应结果
         */
        const fetchValidationResult = async (params) => {
            try {
                const url = sceneUrlMap[props.scene];
                return await proxy.$hPost(url, params);
            } catch (error) {
                return {};
            }
        };

        /**
         * 处理验证结果
         * @param {Array} validateResults - 验证结果数组
         * @returns {Array} 处理后的验证结果
         */
        const processValidationResults = (validateResults) => {
            // 先过滤出符合条件的结果
            const filteredResults = validateResults.filter((item) => {
                const config = validationConfig[item.type];
                return config && item.code === codeMap.needOpen;
            });

            // 按 type 分组合并 message
            const groupedResults = {};
            filteredResults.forEach((item) => {
                if (!groupedResults[item.type]) {
                    groupedResults[item.type] = {
                        type: item.type,
                        code: item.code,
                        messages: [],
                    };
                }
                groupedResults[item.type].messages.push(item.message);
            });

            // 转换为最终格式，合并 message
            return Object.values(groupedResults).map((group) => ({
                weakValidTitle: validationConfig[group.type].title,
                type: group.type,
                code: group.code,
                message: group.messages.filter((item) => item).join('<br>'),
            }));
        };

        /**
         * 处理验证流程
         * @param {Array} processedResults - 处理后的验证结果
         */
        const handleValidationFlow = (processedResults) => {
            if (processedResults.length > 0) {
                weakValidateResult.value = processedResults;
                visible.value = true;
            } else {
                proxy.$emit('continue');
            }
        };

        // 打开弱校验弹窗
        const handleOpen = async (params) => {
            // 获取验证结果
            const validateResponse = await fetchValidationResult(params);
            // 处理验证结果
            const processedResults = processValidationResults(validateResponse?.weakValidateResult || []);
            // 处理验证流程
            handleValidationFlow(processedResults);
        };

        // 取消
        const handleCancel = () => {
            weakValidateResult.value = [];
            visible.value = false;
            proxy.$emit('cancel');
        };

        // 提交
        const handleContinue = () => {
            proxy.$emit('continue');
            handleCancel();
        };

        return {
            visible,
            weakValidateResult,
            handleOpen,
            handleCancel,
            handleContinue,
        };
    },
};
</script>
